import React, { useEffect, useCallback, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import useMixpanelEventAction from "../../config/mixpanel/useMixpanelEventAction";
import useGA4EventAction from "../../config/GoogleAnalytics/useGA4EventAction";
import privateAxios from "../../utils/axiosPrivate";
import { callBackComp } from "../../locales/en";
import { getBillingRequestStatusUrl } from "../../utils/constants/apiEndPoints";
import { COMPLETE_ACCOUNT_SETUP, INVOICE } from "../../route/paths";
import { showToast } from "../../utils/utils";
import {
  GOCARDLESS_SETUP_COMPLETE_MESSAGE,
  showToastType
} from "../../utils/constants/appConstants";

const GocardLessCallBack = () => {
  const navigate = useNavigate();
  const { completeAMLMixpanelEvent } = useMixpanelEventAction();
  const { idVerificationGA4Event } = useGA4EventAction();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const idParams = queryParams.get("billingRequestId");
  const flowParam = queryParams.get("billingRequestFlows");
  const isFirstLoad = useRef(true);
  const isEmbeddedInIframe = window.self !== window.top;

  const handleRequestBillingGocardless = useCallback(async () => {
    try {
      await privateAxios.post(getBillingRequestStatusUrl(idParams));
      completeAMLMixpanelEvent();
      idVerificationGA4Event(idParams);

      if (isEmbeddedInIframe) {
        window.parent.postMessage(
          { type: GOCARDLESS_SETUP_COMPLETE_MESSAGE },
          window.location.origin
        );
        return;
      }

      navigate(INVOICE, { state: { showGoCardlessModal: true } });
    } catch (error) {
      showToast(error.response.data.message, showToastType.error);
    }
  }, [
    privateAxios,
    idParams,
    completeAMLMixpanelEvent,
    idVerificationGA4Event,
    navigate,
    isEmbeddedInIframe
  ]);

  useEffect(() => {
    if (isFirstLoad.current) {
      if (flowParam === "exit") {
        navigate(COMPLETE_ACCOUNT_SETUP);
      } else if (idParams) {
        handleRequestBillingGocardless();
      }
      isFirstLoad.current = false;
    }
  }, [flowParam, idParams, handleRequestBillingGocardless, navigate]);

  return <h5 className="text-dark">{callBackComp.doNotRefresh}</h5>;
};

export default GocardLessCallBack;
